import React from "react";
import "../Feedback/Css/style.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import patientPic from "./Images/patientPic.png";

const testimonials = [
  {
    id: 1,
    name: "Sindhu Pillai",
    title: "IT Professional",
    tags: ["Diabetes Patient", "Chronic Disease Management"],
    feedback: `After weeks of avoiding clinics for my joint pain I called Kyno’s Doctor. It was super conveninient- no crowded waiting rooms, no travel. Just a swift checkup at my own home.`,
    image: patientPic, // Replace with your image path
    city: "Delhi",
  },
  {
    id: 2,
    name: "Makrand Shreelochan",
    title: "Teacher",
    tags: ["Diabetes Patient", "Chronic Disease Management"],
    feedback: `Doctor actually reached in less than 30 minutes! Surprisingly quick and helpful even after the visit till i recovered fully. It's a very innovative service.. 

I always recommend them to everyone 10/10.`,
    image: patientPic, // Replace with your image path
    city: "Delhii",
  },
  {
    id: 3,
    name: "Rajesh",
    title: "Teacher",
    tags: ["Diabetes Patient", "Chronic Disease Management"],
    feedback: `I called a general physician for loose motion and weakness. The consultation lasted more than half hour & doctor gave medicines right away. I was feeling better same day itself. Great service!`,
    image: patientPic, // Replace with your image path
    city: "Noida",
  },
  {
    id: 4,
    name: "Nitu Kiran",
    title: "Teacher",
    tags: ["Diabetes Patient", "Chronic Disease Management"],
    feedback: `I booked a consultation for my mother from office without taking a leave. Took 3 follow ups also without any fuss. 
 
Quite affordable and superb service. `,
    image: patientPic, // Replace with your image path
    city: "Bangalore",
  },
  {
    id: 5,
    name: "Venugopal Ayilliath",
    title: "Teacher",
    tags: ["Diabetes Patient", "Chronic Disease Management"],
    feedback: `Called Dr. Shalini from Kyno Health for high fever around 4am. It's so convinient that doctors are available 24/7. She was so thorough. I have called her for my parents and recommended to my friends also. Dr. Shalini has become our family doctor now.`,
    image: patientPic, // Replace with your image path
    city: "Bangalore",
  },
  {
    id: 6,
    name: "Sowmya H",
    title: "Teacher",
    tags: ["Diabetes Patient", "Chronic Disease Management"],
    feedback: `Excellent medical service. They sent Dr Rajeena when I had dengue. She was very polite and kind. Very professional service, they even sent doctor at night.

Thank you Kyno Health!`,
    image: patientPic, // Replace with your image path
    city: "Bangalore",
  },
  {
    id: 7,
    name: "Soundarya Nachappa",
    title: "Teacher",
    tags: ["Diabetes Patient", "Chronic Disease Management"],
    feedback: `I had kidney stones and the pain was unbearable. Kyno sent the physician immediately and got pain relief injection within 15 minutes, that too at 3 am.

Life saving service!`,
    image: patientPic, // Replace with your image path
    city: "Bangalore",
  },
  {
    id: 8,
    name: "Shahnaz Naseem",
    title: "Teacher",
    tags: ["Diabetes Patient", "Chronic Disease Management"],
    feedback: `Now that this service is here, there is no need to go to a clinic or hospital. The doctor is always available near me. This service is a blessing in disguise 😃`,
    image: patientPic, // Replace with your image path
    city: "Bangalore",
  },
  {
    id: 6,
    name: "Yuvika Mishra",
    title: "Teacher",
    tags: ["Diabetes Patient", "Chronic Disease Management"],
    feedback: `Such a really good doctor I am very impressed with her very friendly very motivated and affordable thanks kyno health for your best service at home ❤️❤️❤️❤️`,
    image: patientPic, // Replace with your image path
    city: "Bangalore",
  },
  {
    id: 9,
    name: "Sumit Basu",
    title: "Teacher",
    tags: ["Diabetes Patient", "Chronic Disease Management"],
    feedback: `very prompt and effective service. i have used their service twice and the doctors were very kind and capable. thank you.`,
    image: patientPic, // Replace with your image path
    city: "Bangalore",
  },
  {
    id: 10,
    name: "Ajay Thakur",
    title: "Teacher",
    tags: ["Diabetes Patient", "Chronic Disease Management"],
    feedback: `Excellent service by Kyno and Doctor who visited to my place is highly knowledgeable and explained everything perfectly , Highly recommended.`,
    image: patientPic, // Replace with your image path
    city: "Bangalore",
  },
  {
    id: 11,
    name: "KADAMBARI SRIKANTHAN",
    title: "Teacher",
    tags: ["Diabetes Patient", "Chronic Disease Management"],
    feedback: `This is a new organ[ization] at Bangalore. Came to know of it thru Google search. The doctor came for a home visit promptly and prescribed medicines. Her visit was very helpful`,
    image: patientPic, // Replace with your image path
    city: "Bangalore",
  },
  {
    id: 12,
    name: "Kyno Patient",
    title: "Teacher",
    tags: ["Diabetes Patient", "Chronic Disease Management"],
    feedback: `We had a wonderful experience as doctor's visit at home was a big relief for our ageing great grand mother-in-law. One must try.`,
    image: patientPic, // Replace with your image path
    city: "Bangalore",
  },
  // Add more testimonial objects as needed
];

let getInitials = function (name) {
  const words = name.split(" ");
  if (words.length == 1) {
    return words[0].slice(0, 2).toUpperCase();
  }
  let initials = "";
  let count = 0;
  words.forEach((word) => {
    if (count >= 2) {
      return;
    }
    initials += word.charAt(0).toUpperCase();
    count++;
  });
  return initials;
};

const INFINITE = 9999999999999;

function Feedback({
  slidesPerViewMobile = 2,
  slidesPerViewDesktop = 3,
  autoscroll = true,
}) {
  return (
    <section className="patient-carousel">
      <h2 className="carousel-heading">Google Rating</h2>
      <div className="carsouel_inner">
        <Swiper
          modules={[Pagination, Autoplay]}
          spaceBetween={30}
          // slidesPerView={1}
          pagination={{ clickable: true }}
          autoplay={{
            delay: autoscroll ? 4000 : INFINITE, // 3-second delay between slides
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          loop={true}
          breakpoints={{
            768: { slidesPerView: slidesPerViewMobile || 2 },
            1024: { slidesPerView: slidesPerViewDesktop || 3 },
          }}
          className=""
          key={Math.random(0, 99999)}
        >
          {testimonials.map((testimonial) => (
            <SwiperSlide key={testimonial.id}>
              <div className="carsouel_item">
                <div className="review_card treatmentPageReviewCard">
                  <div className="reviewcard_header">
                    <div className="reviewcard_image">
                      <span>{getInitials(testimonial.name)}</span>
                    </div>
                    <div className="reviewcard_detail">
                      <p className="reviewcard_name">{testimonial.name}</p>
                      <div className="reviewcard_star_thumb">
                        <div
                          className="reviewcard_star_ratings"
                          title="5 Stars"
                        >
                          <svg
                            viewBox="0 0 51 48"
                            className="widget-svg"
                            style={{
                              width: "11px",
                              height: "11px",
                              transition: "transform 0.2s ease-in-out 0s",
                            }}
                          >
                            <path
                              className="star"
                              d="m25,1 6,17h18l-14,11 5,17-15-10-15,10 5-17-14-11h18z"
                              style={{
                                fill: "rgb(255, 204, 0)",
                                transition: "fill 0.2s ease-in-out 0s",
                              }}
                            ></path>
                          </svg>
                          <svg
                            viewBox="0 0 51 48"
                            className="widget-svg"
                            style={{
                              width: "11px",
                              height: "11px",
                              transition: "transform 0.2s ease-in-out 0s",
                            }}
                          >
                            <path
                              className="star"
                              d="m25,1 6,17h18l-14,11 5,17-15-10-15,10 5-17-14-11h18z"
                              style={{
                                fill: "rgb(255, 204, 0)",
                                transition: "fill 0.2s ease-in-out 0s",
                              }}
                            ></path>
                          </svg>
                          <svg
                            viewBox="0 0 51 48"
                            className="widget-svg"
                            style={{
                              width: "11px",
                              height: "11px",
                              transition: "transform 0.2s ease-in-out 0s",
                            }}
                          >
                            <path
                              className="star"
                              d="m25,1 6,17h18l-14,11 5,17-15-10-15,10 5-17-14-11h18z"
                              style={{
                                fill: "rgb(255, 204, 0)",
                                transition: "fill 0.2s ease-in-out 0s",
                              }}
                            ></path>
                          </svg>
                          <svg
                            viewBox="0 0 51 48"
                            className="widget-svg"
                            style={{
                              width: "11px",
                              height: "11px",
                              transition: "transform 0.2s ease-in-out 0s",
                            }}
                          >
                            <path
                              className="star"
                              d="m25,1 6,17h18l-14,11 5,17-15-10-15,10 5-17-14-11h18z"
                              style={{
                                fill: "rgb(255, 204, 0)",
                                transition: "fill 0.2s ease-in-out 0s",
                              }}
                            ></path>
                          </svg>
                          <span className="rating_count review_card_font">
                            {" "}
                            5/5{" "}
                          </span>
                        </div>
                        <div className="reviewcard_record">
                          <p className="reviewcard_recommended">
                            <img
                              width="10px"
                              height="10px"
                              src="https://img.pristyncare.com/static_pages%2FcompanyClinic%2FIcon%20open-thumb-up.svg"
                              alt="thumbs up"
                            />
                            <span className="" style={{ marginLeft: "10px" }}>
                              Recommends
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="reviewcard_content">
                    <p className="reviewcard_desc"> {testimonial.feedback}</p>
                  </div>
                  <div className="reviewcard_bottom">
                    <div className="reviewcard_city">
                      City : <span>{testimonial.city}</span>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}

export function FeedbackV2({
  slidesPerViewMobile = 1,
  slidesPerViewDesktop = 3,
  autoscroll = true,
}) {
  return (
    <section className="patient-carousel patient-carousel-v2">
      <h2 className="carousel-heading carousel-heading-v2">
        <svg
          viewBox="0 0 51 48"
          className="widget-svg"
          style={{
            width: "15px",
            height: "15px",
            transition: "transform 0.2s ease-in-out 0s",
            marginBottom: "4px",
          }}
        >
          <path
            className="star"
            d="m25,1 6,17h18l-14,11 5,17-15-10-15,10 5-17-14-11h18z"
            style={{
              fill: "rgb(255, 204, 0)",
              transition: "fill 0.2s ease-in-out 0s",
            }}
          ></path>
        </svg>{" "}
        4.9 Google Reviews
      </h2>
      <div className="carsouel_inner">
        <Swiper
          modules={[Pagination, Autoplay]}
          spaceBetween={30}
          // slidesPerView={1}
          pagination={{ clickable: true }}
          autoplay={{
            delay: autoscroll ? 4000 : INFINITE, // 3-second delay between slides
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          loop={true}
          breakpoints={{
            768: { slidesPerView: slidesPerViewMobile || 2 },
            1024: { slidesPerView: slidesPerViewDesktop || 3 },
          }}
          className=""
          style={{ "--swiper-pagination-color": "#179D82" }}
          key={Math.random(0, 99999)}
        >
          {testimonials.map((testimonial) => (
            <SwiperSlide key={testimonial.id}>
              <div className="carsouel_item">
                <div className="review_card review_card-v2 treatmentPageReviewCard">
                  <div className="reviewcard_header">
                    <div className="reviewcard_image reviewcard_image-v2 ">
                      <span>{getInitials(testimonial.name)}</span>
                    </div>
                    <div className="reviewcard_detail">
                      <p className="reviewcard_name">{testimonial.name}</p>
                    </div>
                  </div>
                  <div className="reviewcard_star_thumb">
                    <div
                      className="reviewcard_star_ratings reviewcard_star_ratings-v2"
                      title="5 Stars"
                    >
                      <svg
                        viewBox="0 0 51 48"
                        className="widget-svg"
                        style={{
                          width: "11px",
                          height: "11px",
                          transition: "transform 0.2s ease-in-out 0s",
                        }}
                      >
                        <path
                          className="star"
                          d="m25,1 6,17h18l-14,11 5,17-15-10-15,10 5-17-14-11h18z"
                          style={{
                            fill: "rgb(255, 204, 0)",
                            transition: "fill 0.2s ease-in-out 0s",
                          }}
                        ></path>
                      </svg>
                      <svg
                        viewBox="0 0 51 48"
                        className="widget-svg"
                        style={{
                          width: "11px",
                          height: "11px",
                          transition: "transform 0.2s ease-in-out 0s",
                        }}
                      >
                        <path
                          className="star"
                          d="m25,1 6,17h18l-14,11 5,17-15-10-15,10 5-17-14-11h18z"
                          style={{
                            fill: "rgb(255, 204, 0)",
                            transition: "fill 0.2s ease-in-out 0s",
                          }}
                        ></path>
                      </svg>
                      <svg
                        viewBox="0 0 51 48"
                        className="widget-svg"
                        style={{
                          width: "11px",
                          height: "11px",
                          transition: "transform 0.2s ease-in-out 0s",
                        }}
                      >
                        <path
                          className="star"
                          d="m25,1 6,17h18l-14,11 5,17-15-10-15,10 5-17-14-11h18z"
                          style={{
                            fill: "rgb(255, 204, 0)",
                            transition: "fill 0.2s ease-in-out 0s",
                          }}
                        ></path>
                      </svg>
                      <svg
                        viewBox="0 0 51 48"
                        className="widget-svg"
                        style={{
                          width: "11px",
                          height: "11px",
                          transition: "transform 0.2s ease-in-out 0s",
                        }}
                      >
                        <path
                          className="star"
                          d="m25,1 6,17h18l-14,11 5,17-15-10-15,10 5-17-14-11h18z"
                          style={{
                            fill: "rgb(255, 204, 0)",
                            transition: "fill 0.2s ease-in-out 0s",
                          }}
                        ></path>
                      </svg>
                      <span className="rating_count review_card_font">
                        {" "}
                        5/5{" "}
                      </span>
                    </div>
                    <div className="reviewcard_record">
                      <p className="reviewcard_recommended">
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 15 15"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0_214_698)">
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M7.70166 0.9375C4.0831 0.9375 1.13916 3.88144 1.13916 7.5C1.13916 11.1186 4.0831 14.0625 7.70166 14.0625C11.3202 14.0625 14.2642 11.1186 14.2642 7.5C14.2642 3.88136 11.3202 0.9375 7.70166 0.9375Z"
                              fill="#46CC6B"
                            />
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M8.61631 13.9986C8.76988 13.977 8.92172 13.9502 9.07186 13.9183C9.36982 13.8547 9.66295 13.7703 9.9491 13.6657L9.9494 13.666C10.3562 13.5171 10.7471 13.3281 11.1165 13.1019L11.1175 13.1013C11.1261 13.096 11.1347 13.0908 11.1433 13.0855C11.4046 12.9239 11.6543 12.7443 11.8905 12.5479C11.9334 12.5123 11.9757 12.4761 12.0176 12.4394C12.4758 12.0386 12.8765 11.5765 13.2083 11.0661C13.266 10.9773 13.3216 10.8871 13.3751 10.7954C13.3817 10.7844 13.3883 10.7733 13.3947 10.7621C13.5391 10.5112 13.6666 10.251 13.7764 9.98323L13.7788 9.97733L13.7846 9.96322L13.7894 9.95146L13.7913 9.94657C13.8379 9.83123 13.8812 9.71431 13.9212 9.5958L13.9232 9.58979L10.9895 6.3145L11.0108 6.33911L11.0317 6.36541L11.0523 6.39352L11.0923 6.45318L11.1183 6.49568L8.72651 3.82764L8.76479 3.87232L8.80096 3.91935L8.83498 3.96857L8.86681 4.02014L8.89648 4.074L8.92382 4.13L8.94911 4.18811L8.97219 4.24827L8.99305 4.31047L9.01173 4.37462L9.02814 4.44068L9.04236 4.50861L9.05436 4.57839L9.06412 4.64989L9.07164 4.72314L9.07692 4.79801L9.07993 4.87457L9.08069 4.95264L9.07919 5.03224L9.07544 5.11331L9.0694 5.19578L9.0612 5.27962L9.05059 5.36479L9.03765 5.4512L9.02245 5.5387L9.00492 5.62751L8.9851 5.71742L8.96292 5.80836L8.93848 5.9004L8.91165 5.99337L8.90971 6.00073L8.90815 6.00811L8.90709 6.01552L8.90643 6.02296L8.90621 6.03042L8.9064 6.03786L8.90706 6.04527L8.9081 6.0526L8.90957 6.05987L8.91146 6.06706L8.91379 6.07417L8.91652 6.08112L8.91964 6.08793L8.92316 6.09457L8.9271 6.10105L8.93139 6.10734L8.93607 6.11333L8.94107 6.11899L11.3801 8.70757L11.3644 8.78109L11.3426 8.87311L11.3183 8.96476L11.2918 9.05587L11.2683 9.13025L11.2435 9.20334L11.2174 9.27514L11.1901 9.34558L11.1614 9.41465L11.1316 9.48238L11.1005 9.54866L11.0683 9.61352L11.0349 9.67687L11.0004 9.73875L10.9648 9.7991L10.9281 9.85789L10.8902 9.91512L10.8514 9.97071L10.8115 10.0247L10.7705 10.077L10.7286 10.1278L10.6858 10.1767L10.642 10.2238L10.5973 10.2692L10.5517 10.3128L10.5052 10.3546L10.4579 10.3944L10.4098 10.4324L10.3608 10.4685L10.311 10.5027L10.2606 10.5349L10.2093 10.5649L10.1574 10.5931L10.1334 10.6051L5.65239 6.24327L5.6738 6.26574L5.69414 6.28923L5.71328 6.31365L5.73133 6.339L5.74814 6.36525L5.76376 6.39234L5.77806 6.42021L5.79099 6.44884L5.80259 6.47818L5.81279 6.50825L5.82151 6.53891L5.82873 6.57016L5.83444 6.60199L5.83857 6.63431L5.84103 6.66712L5.84191 6.70034V9.94487L5.84103 9.97809L5.83857 10.0109L5.83444 10.0432L5.82873 10.0751L5.82151 10.1063L5.81279 10.137L5.80259 10.167L5.79099 10.1964L5.77806 10.225L5.76376 10.2529L5.74814 10.2799L5.73133 10.3062L5.71328 10.3315L5.69414 10.356L5.6738 10.3795L5.65239 10.4019L5.62991 10.4233L5.60642 10.4437L5.582 10.4628L5.55666 10.4809L5.53041 10.4977L5.50334 10.5133L5.47547 10.5276L5.44684 10.5406L5.4175 10.5521L5.38743 10.5623L5.3568 10.571L5.32552 10.5782L5.29372 10.5839L5.2614 10.5881L5.22859 10.5906L5.19536 10.5914H4.58833L4.55514 10.5906L4.52232 10.5881L4.49003 10.5839L4.4582 10.5782L4.42695 10.571L4.3963 10.5623L4.36622 10.5521L4.33688 10.5406L4.30825 10.5276L4.28036 10.5133L4.25329 10.4977L4.22704 10.4809L4.20169 10.4628L4.17725 10.4437L8.43103 14.0219C8.49308 14.0149 8.55484 14.0071 8.61631 13.9986Z"
                              fill="#179D82"
                            />
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M5.19541 10.5916H4.58838C4.41697 10.5914 4.25263 10.5232 4.13143 10.4019C4.01023 10.2807 3.94207 10.1164 3.94189 9.94496V6.7004C3.94207 6.52898 4.01024 6.36463 4.13144 6.24341C4.25265 6.12219 4.41699 6.054 4.58841 6.0538H5.19544C5.36687 6.05398 5.53122 6.12217 5.65244 6.24339C5.77365 6.36461 5.84182 6.52897 5.84198 6.7004V9.94496C5.84181 10.1164 5.77364 10.2807 5.65243 10.402C5.53122 10.5232 5.36684 10.5914 5.19541 10.5916ZM11.2919 9.05617C11.0484 9.85612 10.5766 10.4427 9.99741 10.6655C8.8189 11.1188 7.03926 10.6619 6.05833 10.2205C6.08685 10.1315 6.10135 10.0385 6.10131 9.94496V6.7004C6.10131 6.67172 6.09981 6.6435 6.09721 6.61544L7.23783 5.34478C7.32672 5.24574 7.40052 5.16705 7.4598 5.10374C7.75785 4.78571 7.76914 4.757 7.76406 4.33426C7.76294 4.24187 7.76157 4.12678 7.76365 3.98074C7.76638 3.78703 7.84664 3.6455 7.98951 3.58228C8.17886 3.49831 8.43546 3.56251 8.64335 3.74569C9.10981 4.15678 9.21016 4.99708 8.91179 5.99365C8.90602 6.01287 8.9048 6.03317 8.90822 6.05294C8.91163 6.07272 8.9196 6.09143 8.93148 6.1076C8.94336 6.12377 8.95884 6.13696 8.97669 6.14613C8.99454 6.1553 9.01427 6.1602 9.03434 6.16044C9.38612 6.16515 9.67659 6.1462 9.93286 6.12965C10.5682 6.08847 10.8347 6.0841 11.0523 6.39355C11.4906 7.01696 11.5869 8.08698 11.2919 9.05617Z"
                              fill="#F6F6F6"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_214_698">
                              <rect
                                width="14"
                                height="14"
                                fill="white"
                                transform="translate(0.70166 0.5)"
                              />
                            </clipPath>
                          </defs>
                        </svg>

                        <span className="" style={{ marginLeft: "10px" }}>
                          Recommends
                        </span>
                      </p>
                    </div>
                  </div>
                  <div className="reviewcard_content">
                    <p className="reviewcard_desc reviewcard_desc-v2">
                      {" "}
                      {testimonial.feedback}
                    </p>
                  </div>
                  <div className="reviewcard_bottom">
                    <div className="reviewcard_city">
                      City : <span>{testimonial.city}</span>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}
export default Feedback;
